module.exports = window.__clic_libs["@codemirror/state"];